import { Card, CardContent, Typography, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ExitPageProps {
  expired?: boolean;
}

export default function ExitPage({ expired = false }: ExitPageProps) {
  return (
    <Card>
      <CardContent sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          {expired ? (
            <WarningAmberIcon sx={{ fontSize: 80, color: 'warning.main' }} aria-hidden="true" />
          ) : (
            <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main' }} aria-hidden="true" />
          )}
        </Box>

        <Typography variant="h4" component="h1" gutterBottom>
          {expired ? 'Session Expired' : 'Thank You'}
        </Typography>

        {expired ? (
          <>
            <Typography variant="body1" paragraph color="text.secondary">
              Your session has expired due to inactivity.
            </Typography>
            <Typography variant="body1" paragraph>
              Please refresh the page to start a new session if you would like to take the assessment.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body1" paragraph color="text.secondary">
              Thank you for your time. We respect your decision.
            </Typography>
            <Typography variant="body1" paragraph>
              If you change your mind and would like to participate in the future, 
              please speak with your instructor or visit this page again.
            </Typography>
            <Typography variant="body1" paragraph>
              Best wishes for your success in Precalculus I!
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
}
